import { PropTypes } from "prop-types";
import { useEffect, useState } from "react";
import { StyledUserCard } from "../../../styles/StyledUserCard/StyledUserCard";
import { MoreActions } from "../../MoreActions";
import { Select } from "../../Select";
import CloseIcon from "../../../assets/img/icons/close.svg";
import SaveIcon from "../../../assets/img/icons/save.svg";
import { changeUnitMemberRole } from "../../../api/unit/members";
import { useUnitContext } from "../../../context/unitContext";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

export default function MemberCard({
	data,
	color,
	openDropdowns,
	setOpenDropdowns,
	direction,
	moreActionsPosition,
	openModal,
	refetch,
	showOptions,
}) {
	const { axiosPrivate } = useAxiosPrivate();
	const { id: unitId } = useUnitContext();
	const [edit, setEdit] = useState(false);
	const [value, setValue] = useState([]);
	const { roles, user } = data;
	const { id, firstName, lastName } = user;
	const name = firstName + " " + lastName;

	useEffect(() => {
		const roleValues = data.roles.map((e) => {
			switch (e) {
				case "owner":
					return { value: "owner", label: "Unit Owner" };
				case "decision-maker":
					return { value: "decision-maker", label: "Decision Maker" };
			}
		});
		setValue(roleValues);
	}, []);

	const roleValues = data.roles.map((e) => {
		switch (e) {
			case "owner":
				return { value: "owner", label: "Unit Owner" };
			case "decision-maker":
				return { value: "decision-maker", label: "Decision Maker" };
		}
	});

	const handleRoleChange = async () => {
		setEdit(false);
		await changeUnitMemberRole(axiosPrivate, refetch, unitId, id, { roles: [...value.map((e) => e.value)] });
	};

	let acronym = "";
	name.split(" ").map((e, i) => {
		if (i < 2) acronym += e.split("")[0];
	});

	return (
		<StyledUserCard color={color}>
			{showOptions && (
				<MoreActions
					type={`p${id}`}
					options={[
						{
							display: true,
							testId: `p${id}-delete`,
							name: "Remove member",
							click: () => openModal(id),
						},
						{
							display: true,
							testId: `p${id}-role`,
							name: "Change roles",
							click: () => setEdit(true),
						},
					]}
					isOpen={openDropdowns}
					setIsOpen={setOpenDropdowns}
					isDisabled={false}
					direction={direction}
					moreActionsPosition={moreActionsPosition}
				/>
			)}
			<div className="user-header">
				<div className="user-picture">
					<span>{acronym}</span>
				</div>
				<div>
					<span className="user-label">Name</span>
					<h5>{name}</h5>
				</div>
			</div>
			<span className="user-label">Role</span>
			{edit ? (
				<>
					<Select
						options={[
							{ value: "owner", label: "Unit Owner" },
							{ value: "decision-maker", label: "Decision Maker" },
						]}
						value={value}
						defaultValues={roleValues}
						onChangeMulti={(e) => {
							setValue(e);
						}}
						id="role"
						name="role"
						data-testid="role"
						isMulti={true}
					/>
					<div className="user-role-buttons">
						<img
							onClick={() => {
								handleRoleChange();
							}}
							src={SaveIcon}
							alt={SaveIcon}
							role="img"
						/>
						<img
							onClick={() => {
								setEdit(false);
							}}
							src={CloseIcon}
							alt={CloseIcon}
							role="img"
						/>
					</div>
				</>
			) : (
				<h5>
					{roles.map((e, i) => {
						if (e === "decision-maker") {
							let isNext = false;
							for (let j = 0; j < i; j++) {
								if (roles[j] === "owner") isNext = true;
							}
							return isNext ? ", Decision Maker" : "Decision Maker";
						}

						if (e === "owner") {
							let isNext = false;
							for (let j = 0; j < i; j++) {
								if (roles[j] === "decision-maker") isNext = true;
							}
							return isNext ? ", Unit Owner" : "Unit Owner";
						}
					})}
				</h5>
			)}
		</StyledUserCard>
	);
}

MemberCard.propTypes = {
	data: PropTypes.object,
	color: PropTypes.string,
	openDropdowns: PropTypes.object,
	setOpenDropdowns: PropTypes.func,
	refetch: PropTypes.func,
	direction: PropTypes.string,
	moreActionsPosition: PropTypes.string,
	openModal: PropTypes.func,
	showOptions: PropTypes.bool,
};
